var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoshopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#4d8c9f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.24,14.19c-1.27,0-2.17,.03-2.43,.07v8.92c.26,.04,.75,.08,2.11,.08,2.56,0,5.03-.73,5.03-4.5,0-3.01-1.65-4.56-4.7-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.1,0H6.9C3.09,0,0,3.09,0,6.9V43.1C0,46.91,3.09,50,6.9,50H43.1c3.81,0,6.9-3.09,6.9-6.9V6.9C50,3.09,46.91,0,43.1,0ZM16.82,26.84h-2.01v8.57c0,.23-.07,.3-.23,.3h-3.44l-.23-.26V10.83l.19-.27c1.23-.03,3.67-.07,6.13-.07,6.36,0,8.78,3.7,8.81,8.08,0,6-4.47,8.27-9.24,8.27Zm16.89,9.36c-1.69,0-3.82-.16-5.16-1.14l-.19-.38v-3.47l.22-.19c1.66,1.24,3.51,1.6,5.16,1.6,1.46,0,1.97-.98,1.97-1.81,0-.98-.35-1.55-2.65-2.64-3.29-1.58-4.65-2.95-4.65-5.7,0-3.06,2.29-5.58,6.05-5.58,1.94,0,3.31,.05,4.21,.66,.16,.15,.19,.26,.19,.49v3.09c0,.23-.13,.34-.29,.23-1.15-.75-2.77-.99-4.43-.99-1.56,0-1.98,.98-1.98,1.7,0,.9,.41,1.39,2.8,2.52,3.28,1.58,4.68,2.98,4.68,5.69,0,3.77-2.45,5.92-5.96,5.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshopIcon);
export default __webpack_public_path__ + "static/media/photoshop-icon.e374645dc140402aa36903e921b6eb2c.svg";
export { ForwardRef as ReactComponent };